import axiosConfig from "./axiosConfig";

export interface OutageSpan {
  serial_number: string;
  start: string;
  end: string;
  duration_min: number;
  readings: number;
}

export interface HealthEvent {
  id: number;
  siteId: string;
  esysUuid: string | null;
  category: string;
  checkType: string;
  severity: string;
  detectedAt: string;
  resolvedAt: string | null;
  impactType: string;
  month: string | null;
  summary: string;
  notes: string | null;
  details: Record<string, unknown> | null;
  source: string;
  /** "Which Excludable Event" reason, set when the impact is an excused variant
   * (impactType ending in `_excused`). */
  exclusionReason: string | null;
  createdAt: string;
}

export interface AvailabilityPeriod {
  pct: number | null;
  ryg: string;
  periodLabel: string;
  startDate: string;
  endDate: string;
  prevMonthDelta?: number | null;
  contractedPct?: number | null;
}

export interface AvailabilityData {
  lastMonth: AvailabilityPeriod | null;
  last12Months: AvailabilityPeriod | null;
  /**
   * When set, no availability figures could be produced (e.g. site only just
   * went operational and no full prior month exists yet). Frontend should
   * render verbatim.
   */
  noDataReason?: string | null;
}

export interface SiteHealthEventsResponse {
  events: HealthEvent[];
  openEventCount: Record<string, number>;
  availability: AvailabilityData;
  /** BESS availability (24-hour basis), battery sites only; null otherwise. */
  bessAvailability?: AvailabilityData | null;
}

const getSiteHealthEvents = async (
  authToken: string,
  siteId: string,
  from?: string,
  to?: string
): Promise<SiteHealthEventsResponse> => {
  const params: Record<string, string> = {};
  if (from) params.from = from;
  if (to) params.to = to;

  const { data } = await axiosConfig.get(`/site/${siteId}/health/events`, {
    headers: { Authorization: `Bearer ${authToken}` },
    params,
  });
  return data;
};

export default getSiteHealthEvents;
